import {
  FieldPath,
  FieldValues,
  SubmitErrorHandler,
  UseFormHandleSubmit,
  UseFormReset,
  UseFormSetError
} from 'react-hook-form';

import { BadRequestError } from '../api/apiErrors'; // Note - needs to be same instance of BadRequestError

import type { BadRequestFormErrorHandler, ApiSubmitHandler } from '_lib/types/hookForm.types';

interface SubmitHandlerOptions<TFieldValues extends FieldValues> {
  onInvalid?: SubmitErrorHandler<TFieldValues>;
  resetForm?: UseFormReset<TFieldValues>;
}

function setFormErrors<TFieldValues extends FieldValues>(
  setError: UseFormSetError<TFieldValues>,
  err: BadRequestError
) {
  err.responseData?.fieldIssues.forEach((issue) => {
    if (issue.path.length && issue.path) {
      setError(issue.path.join('.') as FieldPath<TFieldValues>, { message: issue.message });
    }
  });
}

function handleBadRequestErrors<TFieldValues extends FieldValues>(
  setError: UseFormSetError<TFieldValues>
): BadRequestFormErrorHandler {
  return (err: BadRequestError) => setFormErrors(setError, err);
}

export function apiSubmitHandler<TFieldValues extends FieldValues>(
  handleSubmit: UseFormHandleSubmit<TFieldValues>,
  setError: UseFormSetError<TFieldValues>,
  onValid: ApiSubmitHandler<TFieldValues>,
  options?: SubmitHandlerOptions<TFieldValues>
) {
  return handleSubmit(async (data, event) => {
    const setFormErrors = handleBadRequestErrors(setError);
    onValid(data, { event, setFormErrors, resetForm: options?.resetForm });
  }, options?.onInvalid);
}
